import type { TDShapeUtil } from "pages/flyer/builder/drawer/state/shapes/TDShapeUtil";
import { TDShape } from "pages/flyer/builder/drawer/types";
import { ShapeUtilsSingleton } from "pages/flyer/builder/drawer/state/shapes/ShapeUtilsSingleton";
//needtorevalidatelogic

export const shapeUtils = () => {
  const utils = ShapeUtilsSingleton.getInstance().getShapeUtils();
  return Object.values(utils); // Assuming utils is an object of shape utilities
};

export const getShapeUtil = <T extends TDShape>(shape: T | T["type"]) => {
  const shapeUtils = ShapeUtilsSingleton.getInstance().getShapeUtils();

  // @ts-ignore
  if (typeof shape === "string") return shapeUtils[shape] as unknown as TDShapeUtil<T>;
  // @ts-ignore
  return shapeUtils[shape.type] as unknown as TDShapeUtil<T>;
};
